<template>
  <div class="home">
    <el-container style="height: 100%; overflow: hidden">
      <el-header v-show="showMenu">
        <div class="header" :style="diyTopColor">
          <router-link to="/home">
            <img :src="logoUrl" class="logo" :class="{ minilogo: !defaultLogo }" />
            <span v-if="userinfo['web_tenantadmin_is_show_productname']" style="line-height: 60px; color: #1e90ff; font-weight: bolder; font-size: 20px">{{ $t(systemName) }}</span>
          </router-link>
          <div class="right">
            <span class="username" style="margin-right: 1em">
              <span>{{ $t("欢迎") }}，</span>{{ userinfo.desc || userinfo.username }}</span>
            <!-- 进入大屏 / 演示大屏 二选一，样式一致 -->
            <el-dropdown
              v-if="userinfo.is_web && (hasStandarDsb || hasCusDsb) && !hasDemoDsb" @command="gotoDsb" class="user-name dsb-entry">
              <div class="dsb-entry-inner">
                <span>{{ $t("进入大屏") }}</span>
              </div>
              <el-dropdown-menu slot="dropdown" style="text-align: center">
                <el-dropdown-item v-if="hasStandarDsb" command="default">{{ $t("标准大屏") }}</el-dropdown-item>
                <el-dropdown-item v-if="hasCusDsb" command="integration">{{ $t("自定义大屏") }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span v-else-if="userinfo.is_web && hasDemoDsb" class="user-name dsb-entry dsb-entry-inner" @click="gotoDsb('demo')">
              {{ $t("演示大屏") }}
            </span>
            <!-- 用户名下拉菜单 -->
            <el-dropdown @command="i18nChange" class="user-name">
              <div style="display: flex; align-items: center; color: #1e90ff; cursor: pointer">
                <span> {{ $i18n.locale == "en" ? "English" : "简体中文" }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
              </div>
              <el-dropdown-menu slot="dropdown" style="text-align: center">
                <el-dropdown-item command="zh">简体中文</el-dropdown-item>
                <el-dropdown-item command="en">English</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="user-name" trigger="hover" @command="handleCommand">
              <div class="el-dropdown-link">
                <div class="logout">
                  <i class="el-icon-more"></i>
                </div>
              </div>
              <el-dropdown-menu style="text-align: center" slot="dropdown">
                <el-dropdown-item v-if="userinfo && userinfo.webuser && userinfo.is_webuser" command="changePassword">{{ $t("修改登录密码") }}</el-dropdown-item>
                <el-dropdown-item divided>
                  <el-dropdown-item command="logout">{{ $t("退出登录") }}</el-dropdown-item>
                </el-dropdown-item>
                <el-dropdown-item v-if="versionNumber" divided disabled>
                  {{ versionNumber }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="logout" @click="openProductDialog" v-if="userinfo.is_webuser" v-show="systemOps.length > 1"
              ><i class="el-icon-sort" style="transform: rotate(0.25turn); margin-right: 1em"></i><span>{{ $t("切换产品") }}</span></span
            >
            <!-- <span class="logout" v-if="userinfo.is_web && hasDashboard" @click="gotoDsb"
              ><span>{{ $t("进入大屏") }}</span></span
            > -->
          </div>
        </div>
      </el-header>
      <el-container class="box-content">
        <el-aside :width="sidebarWidth + 'px'" v-show="showMenu">
          <div class="menu">
            <el-menu :default-active="$route.path" router class="menu_ul" :collapse="isCollapse" :collapse-transition="false">
              <NavMenu :navMenus="menu"></NavMenu>
            </el-menu>
          </div>
        </el-aside>
        <el-main :key="routerKey" :style="mainStyle">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
    <div class="overlay" v-if="isSelect" :class="{ 'overlay--demo': hasDemoDsb }">
      <!-- 非演示模式：保留图片卡片 -->
      <div class="productdialog" v-if="!hasDemoDsb">
        <el-header>
          <i class="el-icon-close" style="float: right; color: #409eff; font-size: 2em; float: right; cursor: pointer; margin: 14px" @click="isSelect = false"></i>
        </el-header>
        <div class="select-dialog">
          <div class="select-title">{{ $t("请选择您要查看的产品，点击进入") }}</div>
          <div class="select-content">
            <!-- :style="{ 'background-image': url(../assets/img/productbg1.jpg), opacity: item.opacity }" -->
            <span
              class="img"
              v-for="(item, index) in systemOps"
              :key="index"
              :style="{ 'background-image': `url(${require(`@/assets/img/productbg${index + 1}.png`)})`, opacity: 1 }"
              @mouseover="changeOpacity(0.8, item)"
              @mouseout="changeOpacity(0.34, index)"
              @click="changeProduct(item.value, item.name)"
            >
              <div>{{ $t(item.name) }}</div>
              <!-- <el-button type="primary" style="margin-top: 8em; width: 70%" @click="changeProduct(item.value, item.name)">点击进入</el-button> -->
            </span>
          </div>
        </div>
      </div>
      <!-- 演示模式：网格布局，等宽等高卡片 -->
      <div v-else class="productdialog" :class="{ 'productdialog--demo': hasDemoDsb }">
        <div class="productdialog__header">
          <h2 v-if="hasDemoDsb" class="productdialog__title">{{ $t("请选择您要查看的产品，点击进入") }}</h2>
          <i class="el-icon-close productdialog__close" @click="isSelect = false"></i>
        </div>
        <div class="select-dialog" :class="{ 'select-dialog--demo': hasDemoDsb }">
          <div class="select-content" :class="{ 'select-content--demo': hasDemoDsb }">
            <!-- 演示模式：无图，以 description 作为产品介绍，遵循 FAB -->
            <div
              v-for="(item, index) in systemOps"
              :key="'demo-' + index"
              class="product-card product-card--demo"
              :class="{ 'product-card--disabled': !isDemoSelectableProduct(item) }"
              :style="{ 'background-image': `url(${require(`@/assets/img/productbg${index + 1}.png`)})` }"
              @click="onDemoProductCardClick(item)"
            >
              <div class="product-card__title">{{ $t(item.name) }}</div>
              <p v-if="item.description" class="product-card__desc">{{ $t(item.description) }}</p>
              <span class="product-card__action">
                {{ $t("点击进入") }}
                <i class="el-icon-arrow-right"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="passwordDialog" :title="$t('重置登录密码')" :visible.sync="passwordDialog" :close-on-press-escape="false" :close-on-click-modal="false" width="40%" center>
      <passwordDialog ref="passwordDialog" v-if="userinfo && userinfo.webuser && userinfo.is_webuser" @changePassword="changePassword" :id="userinfo.webuser" :passwordDialog="passwordDialog" model="webuser"></passwordDialog>
    </el-dialog>
    <el-dialog class="passwordDialog" :title="$t('修改登录密码')" :visible.sync="passwordDialog2" :close-on-press-escape="false" :close-on-click-modal="false" width="40%" center>
      <passwordDialog ref="passwordDialog2" @changePassword="changePassword2" :id="userinfo.id" :passwordDialog="passwordDialog2" model="user"></passwordDialog>
    </el-dialog>
    <el-dialog :title="$t('提示')" center :visible.sync="confirmChangeDialog" width="30%" :show-close="false" :close-on-click-modal="false">
      <span>你已经超过30天未修改密码。是否前往修改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmChange(false)">{{ $t("取 消") }}</el-button>
        <el-button type="primary" @click="confirmChange(true)">{{ $t("确 定") }}</el-button>
        <div style="margin-top: 12px"><el-checkbox v-model="isNoChange">一个月内不要提示</el-checkbox></div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { removeToken, saveToken, getToken } from "@/utils/token";
// import companyImg from "../assets/img/logo.png";
import companyImg from "../assets/img/headericon.png";
import store from "@/store";
import NavMenu from "@/components/navmenu";
import passwordDialog from "@/components/passwordDialog.vue";
import { asyncRouterMap } from "@/router/index";
import VueRouter from "vue-router";
import router from "@/router";
import Vue from "vue";
import { setDemoMode } from "@/mock";
export default {
  data() {
    return {
      systemName: sessionStorage.getItem(`systemName`),
      confirmChangeDialog: false,
      hasStandarDsb: true,
      hasCusDsb: true,
      hasDemoDsb: sessionStorage.getItem("isMock") == "true" ? true : false,
      passwordDialog2: false,
      dsbConfigId: null,
      isNoChange: true,
      notLogOutRoutes: ["/lineManagement/lineUtilization"],
      systemOps: [
        // { value: "MPLS", name: "MV组网", img: "https://files.axshare.com/gsc/6U33HP/52/6f/48/526f484492eb40389925f74f87b7cd2e/images/1__MV组网/u30.jpg?pageId=d0b14712-ac99-432e-a746-184388998eaa", opacity: "0.34" },
        // { value: "SD-Branch", name: "SD-Branch", img: "https://files.axshare.com/gsc/6U33HP/52/6f/48/526f484492eb40389925f74f87b7cd2e/images/1__MV组网/u38.png?pageId=d0b14712-ac99-432e-a746-184388998eaa", opacity: "0.34" },
        // { value: "SD-Security", name: "SD-Security", img: "https://files.axshare.com/gsc/6U33HP/52/6f/48/526f484492eb40389925f74f87b7cd2e/images/1__MV组网/u44.jpg?pageId=d0b14712-ac99-432e-a746-184388998eaa", opacity: "0.34" },
      ],
      isSelect: false,
      companyId: "",
      routerKey: 0,
      logoUrl: "",
      menu: "",
      menuCurrentIndex: "1", // 左侧菜单栏的当前索引
      userid: "",
      userinfo: {},
      // test:
      defaultLogo: false,
      diyTopColor: {},
      versionNumber: "",
      passwordDialog: false,
      showMenu: true,
      logoutTimer: null,
      isCollapse: false,
      sidebarWidth: 220,
      _fsMenuSyncTimer: null,
    };
  },
  beforeDestroy() {
    window.removeEventListener("click", this.resetLogoutTimer);
    window.removeEventListener("resize", this.handleResize);
    document.removeEventListener("fullscreenchange", this.syncMenuFromFullscreen);
    document.removeEventListener("webkitfullscreenchange", this.syncMenuFromFullscreen);
    document.removeEventListener("mozfullscreenchange", this.syncMenuFromFullscreen);
    if (this._fsMenuSyncTimer) {
      clearTimeout(this._fsMenuSyncTimer);
    }
  },
  created() {
    this.resetLogoutTimer();
    window.addEventListener("click", this.resetLogoutTimer);
    document.addEventListener("fullscreenchange", this.syncMenuFromFullscreen);
    document.addEventListener("webkitfullscreenchange", this.syncMenuFromFullscreen);
    document.addEventListener("mozfullscreenchange", this.syncMenuFromFullscreen);
    window.addEventListener("resize", this.handleResize);
    this.handleResize(); // 初始化时执行一次
    this.syncMenuFromFullscreen();
  },
  components: {
    NavMenu,
    passwordDialog,
  },
  watch: {
    "$route.path": {
      handler(newName, oldName) {
        this.resetLogoutTimer();
        this.getMenuCurrentIndex();
      },
      immediate: true,
    },
  },
  async mounted() {
    let token = getToken();
    if (token) {
      let permission = await this.$store.dispatch("getPermission").then((res) => res);
      this.$store.commit("set_Permission", permission);
    }
    if (this.$route.query.token) {
      let userData = await this.$axios
        .get(`/api/user/?username=${this.$route.query.username}`, {
          headers: { Authorization: `Bearer ${this.$route.query.token}` },
        })
        .then((res) => res);
      if (userData.status == 200) {
        let user = userData.data[0];
        saveToken(user.username, this.$route.query.token);
        sessionStorage.setItem("username", user.username);
        let userinfo = JSON.stringify(user);
        sessionStorage.setItem("userinfo", userinfo);
        let permission = await this.$store.dispatch("getPermission").then((res) => res);
        sessionStorage.setItem("permission", JSON.stringify(permission));
        this.$store.commit("set_Permission", permission);
        setTimeout(() => {
          window.location.replace(this.$route.query.isWeb == "1" ? "/#/infomation/infomation" : "/#/user/tenantUser");
          window.location.reload();
        }, 800);
      }
    }
    this.getMenu();
    this.userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
    const isMockMode = sessionStorage.getItem("isMock") === "true";
    if (this.userinfo["is_change"] && !isMockMode) {
      this.confirmChangeDialog = true;
    } else {
      this.confirmChangeDialog = false;
    }
    this.getMenuCurrentIndex();
    sessionStorage.setItem("username", this.userinfo.username);
    if (this.userinfo.is_engineer || this.userinfo.is_superuser) {
      this.logoUrl = companyImg;
      this.diyTopColor = "background-color: #343748";
      this.defaultLogo = true;
    } else {
      this.getCompany();
    }
    if (this.userinfo.is_web) {
      // 演示模式下确保 mock 初始化，使 home.js 拦截 /api/topology/product/get_product/
      if (this.hasDemoDsb) {
        setDemoMode(true);
      }
      this.$store.dispatch("getMenu").then((res) => {
        let standarDsb = res[0].children.find((item) => item.path == "/dashboard/dashboard");
        let cusDsb = res[0].children.find((item) => item.path == "/dashboard/dashboardConfig_web");
        this.hasStandarDsb = standarDsb ? true : false;
        this.hasCusDsb = cusDsb ? true : false;
      });
      let systemType = sessionStorage.getItem(`systemType`);
      if (systemType !== `null` || systemType !== `undefined` || systemType !== "") {
        store.commit("systemType", sessionStorage.getItem(`systemType`));
      }
      this.$backend.product.tenantGet().then((res) => {
        this.systemOps = res.data.data.map((el) => {
          return {
            name: el.name,
            value: el.tag,
            img: "",
            description: el.description || "",
          };
        });
        if (!sessionStorage.getItem(`systemType`) || !sessionStorage.getItem(`systemName`)) {
          sessionStorage.setItem(`systemType`, this.systemOps[0].value);
          sessionStorage.setItem(`systemName`, this.systemOps[0].name);
          this.systemName = this.systemOps[0].name;
          // store.commit("set_systemType", this.systemOps[0].value);
          store.commit("set_systemType", { type: this.systemOps[0].value, name: this.systemOps[0].name });
        }
      });
    }
    this.getVersionNumber();
    this.getNotLogOutRoutes();
    // window.addEventListener("beforeunload", () => {
    //   sessionStorage.setItem("username", this.userid || "");
    // });
  },
  methods: {
    /**
     * 侧栏随浏览器全屏状态切换；不在此处 exitFullscreen，以支持「页面全屏 → 地图全屏 → 退回页面全屏」嵌套场景。
     * 短延迟合并中间态（地图刚退出、尚未恢复 document 全屏时 fs 可能为 null）。
     */
    syncMenuFromFullscreen() {
      if (this._fsMenuSyncTimer) {
        clearTimeout(this._fsMenuSyncTimer);
      }
      this._fsMenuSyncTimer = setTimeout(() => {
        this._fsMenuSyncTimer = null;
        const fs =
          document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement ||
          document.mozFullScreenElement;
        this.showMenu = !fs;
      }, 150);
    },
    async gotoDsb(value) {
      if (value == "demo") {
        console.log("gotoDsb demo");
        this.$router.push({ path: `/dashboard/demoDashboard` });
        return;
      }
      let systemType = value == "integration" ? "INTEGRATION" : sessionStorage.getItem(`systemType`);
      this.dsbConfigId = await this.$backend.dashboardConfig.getByTenant({ product: systemType }).then((res) => {
        if (res.data.error) {
          this.$notify({ title: `${res.data.msg}`, type: "error" });
        }
        return res.data.data.id;
      });
      if (this.dsbConfigId) {
        this.$router.push({ path: `/dashboard/dashboard?id=${this.dsbConfigId}&product=${systemType}` });
      } else {
        this.$router.push({ path: `/dashboard/dashboardConfig_web` });
      }
    },
    resetLogoutTimer() {
      sessionStorage.setItem("lastClickTime", new Date().getTime());
      console.log("clearTimeout", this.logoutTimer);
      clearTimeout(this.logoutTimer); // 清除之前的定时器
      // 免登出路由 或 模拟模式 → 不启动登出定时器
      const isNoLogoutRoute = this.notLogOutRoutes.includes(this.$route.path);
      const isMockMode = sessionStorage.getItem("isMock") === "true";
      if (!isNoLogoutRoute && !isMockMode) {
        this.startLogoutTimer(); // 重新启动定时器
      }
},
    startLogoutTimer() {
      this.logoutTimer = setTimeout(() => {
        let lastClickTime = sessionStorage.getItem("lastClickTime") * 1;
        let nowTime = new Date().getTime();
        console.log("nowTime - lastClickTime", nowTime - lastClickTime);
        if (nowTime - lastClickTime < 30 * 60 * 1000) return;
        removeToken(sessionStorage.getItem("username"));
        this.$confirm(this.$t("你已超过30分钟未操作页面,自动登出"), this.$t("提示"), {
          confirmButtonText: this.$t("确定"),
          type: "warning",
        })
          .then(() => {
            this.logout();
          })
          .catch(() => {
            this.logout();
          }); // 调用登出方法
        }, 30 * 60 * 1000); // 设置为5分钟
      console.log("resetLogoutTimer", this.logoutTimer);
    },
    confirmChange(status) {
      if (status) {
        this.passwordDialog2 = true;
      } else {
        if (this.isNoChange) {
          this.$backend.user.updateAttemptTime(this.userinfo.id, new Date());
        }
      }
      this.userinfo["is_change"] = false;
      sessionStorage.setItem(`userinfo`, JSON.stringify(this.userinfo));
      this.confirmChangeDialog = false;
    },
    getMenu() {
      this.menu = store.state.menuList.sort((a, b) => {
        if (!a.sort) a.sort = 999;
        if (!b.sort) b.sort = 999;
        return a.sort - b.sort;
      });
      this.menu.forEach((el) => {
        if (el.children && el.children.length) {
          el.children.sort((a, b) => {
            if (!a.sort) a.sort = 999;
            if (!b.sort) b.sort = 999;
            return a.sort - b.sort;
          });
        }
      });
    },
    openProductDialog() {
      this.isSelect = true;
    },
    /** 演示模式：仅「AI-WAN（安全定向SD-WAN）」可选，与接口 tag / 名称对齐 */
    isDemoSelectableProduct(item) {
      if (!item) {
        return false;
      }
      if (item.value === "FASTSDWANGUARD") {
        return true;
      }
      const nameFlat = String(item.name || "").replace(/\s+/g, "");
      return nameFlat.indexOf("安全定向SD-WAN") !== -1;
    },
    onDemoProductCardClick(item) {
      if (!this.hasDemoDsb || !this.isDemoSelectableProduct(item)) {
        return;
      }
      this.changeProduct(item.value, item.name);
    },
    changeProduct(type, name) {
      // 演示模式下仅关闭弹窗，不调用接口、不切换产品
      if (this.hasDemoDsb) {
        this.isSelect = false;
        return;
      }
      this.isSelect = false;
      store.commit("set_systemType", { type: type, name: name });
      sessionStorage.setItem(`systemType`, type);
      sessionStorage.setItem(`systemName`, name);
      this.systemName = name;
      store.dispatch("getMenu", "web").then((res) => {
        res.forEach((el) => {
          router.addRoute(el);
        });
        window.location.reload();
        this.getMenu();
        router.push({ path: res[0].children[0].path, replace: true });
        this.routerKey++;
      });
      // sessionStorage.setItem("systemType", type);
    },
    resetRouter() {
      const createRouter = () =>
        new VueRouter({
          mode: "hash",
          routes: router,
        });
      // 用初始化的matcher替换当前router的matcher
      router.matcher = createRouter.matcher;
    },
    changeOpacity(value, item) {
      // console.log("value", value);
      // console.log("item", item);
      // // this.systemOps[index].opacity = value;
      // this.$set(item, "opacity", value);
      // console.log("this.systemOps", item);
    },
    i18nChange(val) {
      if (this.$i18n.locale == val) {
        return;
      } else {
        localStorage.setItem("lang", val);
        this.$i18n.locale = val;
        setTimeout(() => {
          window.location.reload(); //后端的只能通过刷新才能获取新的语言
        }, 100);
      }
    },
    handleCommand(command) {
      if (command == "changePassword") {
        this.passwordDialog = true;
        this.$nextTick(() => {
          this.$refs.passwordDialog.$refs.changePasswordForm.resetFields();
        });
      } else if (command == "logout") {
        this.logout();
      }
    },
    // 通过路由地址判断左侧菜单栏的当前索引值
    getMenuCurrentIndex() {
      this.menuCurrentIndex = this.$route.path;
    },
    getVersionNumber() {
      this.$backend.globalvar
        .get("version_number")
        .then((res) => {
          if (res.data[0]) {
            this.versionNumber = res.data[0].value;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getNotLogOutRoutes() {
      this.$backend.globalvar
        .get("not_logout_routes")
        .then((res) => {
          if (res.data[0]) {
            this.notLogOutRoutes = res.data[0].value;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCompany() {
      this.$axios.get("/api/topology/company/").then((res) => {
        if (res.status == 200 && res.data.length) {
          if (res.data[0].companyimg) {
            this.logoUrl = res.data[0].companyimg;
          } else {
            this.logoUrl = companyImg;
            this.defaultLogo = true;
          }
          if (res.data[0].top_color == res.data[0].gradient_color) {
            this.diyTopColor = `background-color:${res.data[0].top_color};`;
          } else {
            this.diyTopColor = `background-image: linear-gradient(to right,${res.data[0].top_color}, ${res.data[0].gradient_color});`;
          }
        } else {
          this.logoUrl = companyImg;
          this.defaultLogo = true;
          this.diyTopColor = "background-color: #343748";
        }
      });
    },
    changePassword(val) {
      if (val == "success") {
        setTimeout(() => {
          this.logout();
        }, 1000);
      } else {
        this.passwordDialog = val;
      }
    },
    changePassword2(val) {
      if (val == "success") {
        setTimeout(() => {
          this.logout();
        }, 1000);
      } else {
        this.passwordDialog2 = val;
      }
    },
    async logout() {
      try {
        const token = getToken();
        if (token) {
          await this.$backend.login.logout();
        }
      } catch (e) {
        console.warn("logout api", e);
      }
      this.$notify({ title: this.$t("退出成功"), type: "success" });
      removeToken(sessionStorage.getItem("username"));
      sessionStorage.removeItem("systemType");
      store.commit("setmenuList", []);
      store.commit("setrouteList", []);
      sessionStorage.removeItem("username");
      sessionStorage.removeItem("menu");
      sessionStorage.removeItem("userinfo");
      var link = document.querySelector("link[rel*='icon']") || document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = "data:;base64,=";
      document.getElementsByTagName("head")[0].appendChild(link);
      this.$router.push("/");
      location.reload();
    },
    handleResize() {
      // 如果是全屏模式，不执行侧边栏调整
      if (!this.showMenu) {
        return;
      }
      console.log("showMenu");
      const windowWidth = window.innerWidth;
      if (windowWidth <= 1100) {
        this.isCollapse = true;
        this.sidebarWidth = 64;
      } else if (windowWidth >= 1400) {
        this.isCollapse = false;
        this.sidebarWidth = 220;
      } else {
        this.isCollapse = false;
        this.sidebarWidth = Math.max(64, Math.min(220, Math.floor(220 - ((1400 - windowWidth) / 300) * (220 - 64))));
      }
    },
  },
  computed: {
    mainStyle() {
      return {
        width: this.showMenu ? `calc(100% - ${this.sidebarWidth}px)` : "100%",
        transition: "all 0.3s ease",
        minHeight: "100%",
        position: "relative",
        overflow: "auto",
      };
    },
  },
};
</script>
<style scoped>
::v-deep .passwordDialog .el-dialog {
  overflow: hidden;
  border-radius: 13px;
}
::v-deep .passwordDialog .el-dialog__title {
  color: #fff;
}
::v-deep .passwordDialog .el-dialog__body {
  padding: 10px 60px 30px;
}
::v-deep .passwordDialog .el-dialog__header {
  padding: 15px 20px;
  background-color: #409eff;
}
::v-deep .passwordDialog .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
::v-deep .right .el-dropdown {
  line-height: 18px;
}
.collapse-btn {
  height: 50px;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
  border-bottom: 1px solid #4a4d5d;
  color: #fff;
}

.collapse-btn:hover {
  background: #366ae0;
}

/* 处理折叠时的样式 */
.el-menu--collapse {
  width: 64px;
}

.el-aside {
  transition: width 0.3s ease;
}

/* 适配移动端样式 */
@media screen and (max-width: 1200px) {
  .el-main {
    padding: 10px;
  }
}

/* 如果使用了深度选择器，也可以这样写 */
::v-deep .el-menu--collapse .el-submenu__icon-arrow {
  display: none;
}

.el-menu {
  width: 100%;
  transition: width 0.3s ease;
}

/* 当宽度小于特定值时文字逐渐消失 */
::v-deep .el-menu-item span,
::v-deep .el-submenu__title span {
  opacity: 1;
  transition: opacity 0.3s ease;
}

@media screen and (max-width: 1200px) {
  ::v-deep .el-menu-item span,
  ::v-deep .el-submenu__title span {
    opacity: 0;
  }
}
</style>
<style>
.i18nName {
  margin-top: -5px;
  margin-right: 10px;
  cursor: pointer;
}
.home {
  height: 100%;
}
.container {
  height: 100%;
}
.headerbox {
  height: 60px !important;
  /* z-index: 9999; */
}
.el-main {
  padding: 0;
  /* background: #f3f4f9; */
}
.content {
  height: calc(100% - 60px);
}
.aside {
  height: 100%;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: #fff;
  /* background-image: linear-gradient(to right,#e66465, #9198e5); */
  /* z-index: 1000; */
}
.header img {
  margin-left: 20px;
}
.logo {
  margin: 10px 20px;
  float: left;
  height: 40px;
}
.header .right {
  float: right;
  padding-top: 10px;
  line-height: 36px;
  color: #fff;
  margin-right: 1em;
}
.header .note {
  float: left;
  width: 40px;
  height: 35px;
  background: url(../assets/img/email.png) no-repeat center center;
  text-align: center;
  position: relative;
}
.header .note span {
  position: absolute;
  top: 0;
  right: 0px;
  line-height: 16px;
  padding: 0px 4px;
  background: #eb6b5f;
  color: #fff;
  border-radius: 3px;
  font-size: 12px;
}
.header .logout {
  float: left;
  /* padding-left: 30px; */
  font-size: 14px;
  cursor: pointer;
  /* background: url(../assets/img/logout.png) no-repeat left center; */
  margin: 0px 20px;
  color: #1e90ff;
}
.header .headerbutton {
  display: inline-block;
  position: relative;
  color: #606266;
  font-size: 14px;
}
.header .username {
  font-size: 14px;
  color: #f3f4f9;
  padding-right: 30px;
  border-right: 1px solid #1e90ff;
  float: left;
  line-height: 18px;
  margin-top: 10px;
}

/* 进入大屏 / 演示大屏 二选一，统一样式 */
.header .dsb-entry {
  margin-right: 1em;
}
.header .dsb-entry-inner {
  display: inline-flex;
  align-items: center;
  color: #1e90ff;
  cursor: pointer;
  font-size: 14px;
  line-height: 18px;
}

.menu {
  height: 100%;
  background: #343748;
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.menu {
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}
.menu::-webkit-scrollbar {
  width: 7px;
}
.menu::-webkit-scrollbar-track-piece {
  width: 7px;
  background-color: #343748;
  /* -webkit-border-radius: 0; */
}
.menu::-webkit-scrollbar-thumb {
  /* -webkit-border-radius: 0; */
  background-color: #366ae0;
}
.menu ul,
.menu ul li {
  float: left;
  width: 100%;
}
.menu h3 {
  float: left;
  width: 100%;
  line-height: 60px;
  color: #fff;
  font-size: 16px;
  font-weight: normal;
}
.menu h3 a {
  float: left;
  width: 100%;
  font-size: 16px;
  font-weight: normal;
  color: #fff;
}
.menu h3 i {
  float: left;
  margin-left: 5px;
  width: 40px;
}
.menu h3 img {
  float: left;
}
/*.menu .sel{ background: #366AE0;}
	.menu .a{ float: left; line-height: 40px; font-size: 16px; color: #fff; background:url(../assets/img/point.png) no-repeat 90px center; padding-left: 110px;}
*/
.menu p {
  float: left;
  width: 100%;
  padding-bottom: 10px;
}
.menu .secondMenu {
  float: left;
  line-height: 50px;
  font-size: 14px;
  color: #fff;
  background: url(../assets/img/point.png) no-repeat 50px center;
  padding-left: 40px;
  width: 100%;
}

.menu .el-menu {
  background: none;
  border: 0;
}
.menu .el-submenu__title {
  padding: 0;
  height: 60px;
  float: left;
  width: 100%;
}
.el-menu-item-group__title {
  padding: 0;
}
.menu .el-submenu__title i {
  color: #fff;
}
/* .menu .is-opened .el-submenu__title {
  background-color: #366ae0;
} */
.menu .el-submenu__title:hover {
  background-color: #366ae0;
}
.menu .el-menu-item:focus,
.menu .el-menu-item:hover {
  background-color: #366ae0;
}
.menu .el-menu-item {
  height: auto;
  padding: 0;
}
.menu .el-menu-item.is-active {
  background-color: #366ae0;
}
.minilogo {
  height: 46px;
  margin-top: 7px;
}
.box-content {
  position: relative;
  height: calc(100% - 60px);
  overflow-x: hidden;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(127, 127, 127, 0.5);
  z-index: 999;
}
.overlay--demo {
  background-color: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(4px);
}
.productdialog {
  border-radius: 12px;
  height: 75%;
  width: 85%;
  background: url(../assets/img/headerbg.png) no-repeat;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.productdialog--demo {
  /* height:auto; */
  width: 85%;
  min-height: 80%;
  /* max-width: 1200px; */
  background: #f5f7fa;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.18);
}
.productdialog__header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
}
.productdialog--demo .productdialog__header {
  padding: 18px 24px;
  border-radius: 12px 12px 0 0;
}
.productdialog__title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  letter-spacing: 0.02em;
}
.productdialog__close {
  font-size: 22px;
  color: #909399;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: color 0.2s, background 0.2s;
}
.productdialog__close:hover {
  color: #409eff;
  background: rgba(64, 158, 255, 0.08);
}
.select-dialog {
  height: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #333333;
  overflow: hidden;
}
.select-dialog--demo {
  flex: 1;
  height: auto;
  padding: 24px;
  overflow-y: auto;
}
.select-title {
  font-weight: bolder;
  font-size: 2em;
}
.select-content {
  height: 100%;
  margin-top: 2em;
  width: 100%;
  display: flex;
  justify-content: space-around;
}
/* 演示模式：flex布局，一排展示，参考非演示模式 */
.select-content--demo {
  margin-top: 1em;
  height: 100%;
  display: flex;
  justify-content: space-around;
  padding: 0;
}
/* 演示模式 FAB：参考非演示模式卡片尺寸，一排展示 */
.product-card--demo {
  cursor: pointer;
  padding: 22px;
  border-radius: 10px;
  width: 320px;
  min-height: 320px;
  background-color: #fff;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  margin: 0 12px;
  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
  position: relative;
}
/* 为演示模式卡片添加半透明遮罩层，确保文字可读性 */
/* .product-card--demo::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 10px;
  z-index: 0;
} */
.product-card--demo > * {
  position: relative;
  z-index: 1;
}
.product-card--demo:hover {
  border-color: #409eff;
  box-shadow: 0 8px 24px rgba(64, 158, 255, 0.15);
  transform: translateY(-2px);
}
/* 演示模式：不可选产品置灰、不可点击 */
.product-card--demo.product-card--disabled {
  cursor: not-allowed;
  opacity: 0.48;
  filter: grayscale(0.85);
  pointer-events: none;
}
.product-card--demo.product-card--disabled:hover {
  border-color: #e4e7ed;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transform: none;
}
.product-card--demo .product-card__title {
  font-size: 20px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 1em;
  line-height: 1.4;
  width: 100%;
  text-align: center;
  white-space: pre-line;
}
.product-card--demo .product-card__desc {
  flex: 1;
  font-size: 12px;
  color: #606266;
  line-height: 1.7;
  margin: 0 0 16px 0;
  text-align: left;
  /* word-break: keep-all; */
  /* overflow-wrap: break-word; */
  display: -webkit-box;
  -webkit-line-clamp: 5;
  line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.product-card--demo .product-card__action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
  color: #ebebeb;
  font-weight: 800;
  transition: gap 0.2s; 
  width: 100%;
}
.product-card--demo:hover .product-card__action {
  gap: 10px;
}
.product-card--demo .product-card__action .el-icon-arrow-right {
  font-size: 14px;
}
/* 非演示模式：图片卡片 */
.select-content .img {
  cursor: pointer;
  display: flex;
  margin: 0 12px;
  font-size: 2em;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  border-radius: 10px;
  width: 260px;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}
.select-content .img div {
  margin: 1em;
  font-size: 20px;
  font-weight: bold;
}
</style>
